import { useLayoutEffect } from 'react';

import {
	useSetWillRedirectOnLoad,
	useWillRedirectOnLoad,
} from '../will-redirect-on-load-providers';

export const useRedirectOnLoad = <T,>(href: T, redirect: (href: T) => void, condition = true) => {
	const willRedirectOnLoad = useWillRedirectOnLoad();
	const setWillRedirectOnLoad = useSetWillRedirectOnLoad();

	useLayoutEffect(() => {
		if (condition && willRedirectOnLoad) {
			setWillRedirectOnLoad(false);
			redirect(href);
		}
	}, [condition, href, redirect, setWillRedirectOnLoad, willRedirectOnLoad]);
};
